import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingModule } from 'ngx-loading';

import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptorProvider } from './_interceptors/jwt.interceptor';
import { ConfirmationDialogModule } from './_common/dialogs/confirmation/confirmation-dialog.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './_guards/auth.guard';
import { AlertModule } from './_common/alert/alert.module';
import { ModalModule } from './_common/modal/modal.module';
import { LayoutHeaderComponent } from './layout/layout-header/layout-header.component';
import { LayoutFooterComponent } from './layout/layout-footer/layout-footer.component';
import { CartsService } from './_services/carts.service';
import { CountriesService } from './_services/countries.service';
import { LoginService } from './_services/login.service';
import { MarketingService } from './_services/marketing.service';
import { EventPerformersService } from './_services/event-performers.service';
import { PromotionService } from './_services/promotion.service';
import { StyleService } from './_services/style.service';
import { CartItemFilterModule } from './_pipes/cart-item-filter.module';
import { ExperienceShortNameFilterModule } from './_pipes/experience-short-name-filter.module';
import { TimeRemainingModule } from './_pipes/time-remaining.module';
import { WindowRef } from './_common/window-ref/window-ref';

@NgModule({
    bootstrap: [
        AppComponent
    ],
    declarations: [
        AppComponent,
        LayoutHeaderComponent,
        LayoutFooterComponent
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        LoadingModule,
        AlertModule,
        ModalModule,
        CartItemFilterModule,
        ExperienceShortNameFilterModule,
        TimeRemainingModule,
        ConfirmationDialogModule.forRoot()
    ],
    providers: [
        AuthGuard,
        JwtInterceptorProvider,
        CartsService,
        CountriesService,
        LoginService,
        MarketingService,
        EventPerformersService,
        PromotionService,
        StyleService,
        WindowRef
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts